import { type TranslationsKeys } from "./Translations";

const en: TranslationsKeys = {
  CannotUpgradeToTheSamePlan: "Error: You cannot resubscribe to the same plan.",
  MoreThan1ActiveSubscription:
    "Error: You have more than one active subscription.",
  NoBillFoundForCurrentPeriod:
    "You must wait until your subscription starts before you can change it. Return to the start date to change your package!",
  NoPaymentIntentProvided: "Error: No payment intent provided.",
  NoSubscriptions: "Error: No subscriptions.",
  NotASaaSSubscription: "Error: Not a SaaS subscription.",
  NotTheSameCommitment: "Error: Not the same commitment.",
  PaymentFailed:
    "Payment processing failed. Please check your payment method and try again.",
  UnsupportedUseCase: "Error: Unsupported use case.",
  UpsellOk: "UpsellOk",
  UpsellOkWithCompensationBill: "UpsellOkWithCompensationBill",
  a_question: "A question ?",
  actions: "Actions",
  actionsTableHeader: "Actions",
  actions_performed: "Actions performed",
  activate: "Activate",
  active: "Active",
  active_permanently: "Active permanently",
  active_players: "Active players",
  scheduled: "Scheduled",
  scheduled_tooltip:
    "This game was added automatically based on our team's yearly schedule",
  activity: "Activity",
  addPromoCodeButton: "+ Add promo code",
  add_button: "Add a game",
  add_card: "Add a card",
  add_ctas_required: "You must add at least one call-to-action.",
  add_games_required: "You must add at least one game.",
  add_gifts_required:
    "You must add at least one prize, or enable monthly pooled prizes.",
  add_new_card: "Add New Card",
  add_to_basket: "Add to basket",
  added_to_basket: "Added ✅",
  all: "All establishments",
  all_accounts: "All venues",
  ambassador: "Ambassador Program",
  analytics_actions_by_sponsoree_title: "Actions performed by referees",
  analytics_actions_suffix: "actions",
  analytics_business_ctas: "{{count}} business actions",
  analytics_clients_suffix: "cust.",
  analytics_coming_soon: "Coming soon 🚧",
  analytics_distribution_in_euros_title: "Breakdown in {{currency}}",
  analytics_distribution_share_wom_title: "Breakdown by type",
  analytics_email_performance: "Automated email performance",

  analytics_favorite_game_title:
    "🎲 Your customers' favorite game is... {{game}}",
  analytics_favorite_gift_title:
    "🎂 Your customers' favorite prize is... {{gift}}",
  analytics_finance: "💶 Finance",

  analytics_game_distribution: "Distribution by game",
  analytics_games_suffix: "Games",
  analytics_marketing: "📣 Marketing",
  analytics_marketing_ctas: "{{count}} marketing actions",
  analytics_new_business: "New Business",
  analytics_no_avg_basket_button: "Enter my average basket",
  analytics_no_avg_basket_message:
    "Please enter your average basket to see your statistics",
  analytics_no_avg_basket_message_monthly:
    "Please enter your average basket to see your monthly reports",
  analytics_no_players_yet: "You don't have any players yet",
  analytics_no_redeemed_gift:
    "⚠ Your customers didn't redeem any prize on this period",
  analytics_nothing_to_display: "No data.",
  analytics_participation_plural:
    "{{value}} players participated {{label}} times",
  analytics_participation_singular:
    "{{value}} player participated {{label}} times",
  analytics_player_sources: "Active players by source",
  analytics_players: "🙋🏼‍♂️ Players",
  analytics_players_suffix: "players",
  analytics_top_3_actions: "Top 3 actions ⬇️",
  analytics_total_actions_title:
    "👏 {{totalActions}} beneficial actions for your business have been completed",
  analytics_total_players_title:
    "🎯 {{totalPlayers}} people played {{nGamePlayed}} games",
  analytics_total_referral_title:
    "📢 Your customers introduced your business to {{totalReturnReferral}} friends",
  analytics_total_repeat_biz_title:
    "💪 We brought back {{totalRepeatBiz}} customers (i.e. {{totalRepeatBizInCurrency}} in revenue)",
  analytics_use_communication_kit:
    "Use your communication kit to spread your animation and come back here to enjoy your results",
  analytics_virality: "Virality",
  android_bundle_empty_error: "Package identifier must be a non-empty string",
  android_bundle_empty_segment_error: "Segment {{index}} is empty",
  android_bundle_example: "Example: com.example",
  android_bundle_invalid_format_error: "Invalid package identifier format",
  android_bundle_invalid_segment_error:
    "Segment '{{segment}}' is invalid. It must start with a letter and contain only letters, numbers and underscores",
  android_bundle_min_segments_error:
    "Package identifier must have at least two segments",
  android_bundle_reserved_word_error:
    "Segment '{{segment}}' is a reserved Java word",
  android_bundle_segment_too_long_error:
    "Segment '{{segment}}' exceeds the maximum length of 255 characters",
  android_bundle_total_length_error:
    "Total identifier length exceeds maximum of 1000 characters",
  api_error: "Oops something went wrong",
  api_send_email_error: "Something went wrong with send email api",
  api_send_email_success: "Your email successfully sent.",
  api_update_color_error: "An error occurs, unable to update color",
  apple_store_empty_error: "Input must be a non-empty string",
  apple_store_invalid_format_error:
    "Invalid AppRouterWrapper Store identifier or URL format",
  apply: "Apply",
  automated_email: "Automated emails",
  automated_emails: "Automated emails",
  automated_emails_description:
    "Stay in touch with your customers 100% automatically and have them play from home so they never forget you.",
  averageBasketLabel: "Average basket",
  avgBasket: "Average basket",
  bill: "Bill",
  bill_details: "Details",
  bill_download_th: "Bill",
  bill_exceptional_section_heading: "Exceptional invoices",
  bill_filename: "bill",
  bill_number_th: "Number",
  bill_subscription_section_heading: "Subscription invoices",
  billing_address_label: "Billing address",
  billing_country: "Billing country",
  billing_date: "Billing date",
  billing_information: "Billing information",
  birthday: "Date of birth",
  business_profile_active_subscriptions: "Subscriptions",
  business_profile_billing_info: "Billing information",
  business_profile_shipping_info: "Shipping information",
  business_profile_zone3: "Operational information",
  bypass_email_auth: "Disable email authentication",
  bypass_email_auth_warning:
    'The "Invite a friend to play" action will not be available',
  cancel: "Cancel",
  cancelSubscriptionButton: "Cancel",
  cancel_button: "Cancel",
  canceled: "Canceled",
  cannot_order_posa_outside_of_france_text:
    "We invite you to download the templates you like and have them printed at your usual printing partner.",
  cannot_order_posa_outside_of_france_title:
    "Orders of promotional materials are not possible from your country 😕",
  card_error_card_expired: "Your card is expired.",
  card_error_card_inactive:
    "According to your bank, this card is inactive. Please contact your bank.",
  card_error_debit_limit_exceeded:
    "You have exceeded your card's debit limit. Please contact your bank.",
  card_error_debit_transaction_frequency_exceeded:
    "There was a technical issue. Please contact us via the Contact page.",
  card_error_debited_funds_higher_than_pre_authorized_amount:
    "The transaction's amount exceeds the pre-authorization amount. Please contact us via the Contact page.",
  card_error_invalid_or_missing_bank_details:
    "Missing bank data. Please contact us via the Contact page.",
  card_error_maximum_amount_exceeded:
    "You have exceeded your card's maximum payment amount. Please contact your bank.",
  card_error_maximum_number_of_attempts:
    "You have exceeded the maximum number of payment attempts. Please try again later.",
  card_error_maximum_uses_exceeded:
    "You have exceeded the maximum number of payment attempts. Please try again in 24 hours.",
  card_error_not_active:
    "There was a technical issue. Please contact us via the Contact page.",
  card_error_payment_period_expired:
    "The delay to perform this payment is expired.",
  card_error_payment_refused:
    "Transaction refused. Please contact us via the Contact page.",
  card_error_transaction_refused_by_the_bank:
    "Your bank refused this transaction.",
  card_error_transaction_refused_by_the_bank_card_limit:
    "You have reached your card's transaction limit. Please contact your bank.",
  card_expires: "exp.",
  cgv_accept_payment_terms_and:
    "I accept the payment terms mentioned above and the",
  cgv_card_debit_text:
    "Your bank card will be charged {{amount}} monthly until the end of your subscription in order to benefit from the preferential rate of our annual plan.",
  cgv_terms_and_conditions_link_text: "Terms and Conditions of Sale",
  change_plan: "Change plan >>>",
  checkoutFormValidationError: "Error: commitment and/or plan not specified",
  choose_a_model: "Choose a model",
  choose_a_skin: "Choose a skin",
  clear: "Clear",
  clients_per_day_100_to_200: "100 to 200",
  clients_per_day_50_to_100: "50 to 100",
  clients_per_day_less_than_50: "Less than 50",
  clients_per_day_more_than_200: "More than 200",
  clients_per_day_not_relevant: "This number is not relevant to my sector",
  clients_per_day_unknown: "I don't know this number",
  close: "Close",
  code: "Code",
  code_validation_error_exact_digits: "The code must contain exactly 6 digits",
  code_validation_error_no_email: "No email. Redirecting to signup page",
  code_validation_error_required: "The code is required",
  code_validation_footer_different_address: "with a different address.",
  code_validation_footer_or: "or",
  code_validation_footer_resend_email: "Resend email",
  code_validation_footer_restart: "restart",
  code_validation_footer_something_wrong: "Something wrong?",
  code_validation_heading: "A verification code has been sent to your email",
  code_validation_subheading: "Enter the 6-digit code sent to {{email}}",
  colorFormatError: "Invalid color format.",
  colorInputPlaceholder: "#hex,rgb(r,g,b), cmyk(c%,m%,y%,k%)",
  color_background: "Background color",
  color_buttons: "Button color",
  color_secondary: "Secondary color",
  color_subtitle: "Subtitle color",
  color_test_primary: "Primary color",
  color_test_secondary: "Secondary color",
  color_test_title: "Color test",
  color_titles: "Title color",
  comment_placeholder: "Add your comment",
  comments: "Comments",
  commitment_end_label: "Renewal",
  commitment_label: "Commitment",
  configure: "Setup",
  confirm: "Confirm",
  confirm_delete_card: "Are you sure you want to delete this card?",
  confirm_deletion: "Are you sure you want to delete this?",
  confirm_plv_order: "Confirm your order",
  confirm_plv_order_back_button: "Back",
  confirm_plv_order_place_order_button: "Place order",
  confirm_subscription: "Confirm Subscription",
  contact: "Contact",
  continue: "Continue",
  copy_link: "Copy link",
  country_placeholder: "Country",
  coupon_immediate_placeholder: "Prize voucher redeemable immediately",
  coupon_next_day_placeholder:
    "Prize voucher redeemable from the day after winning",
  coupon_redemption_method: "Coupon redemption method",
  coupon_redemption_qr_code: "QR code",
  coupon_redemption_soft_redeem: "Soft-redeem",
  coupon_redemption_validation_code: "Validation code",
  create_custom_design: "Select a template",
  create_first_animation: "Create your first game",
  create_my_free_game: "Create my free game!",
  create_my_game: "Create my game!",
  create_new_animation: "Create a new game",
  cta_buy_and_photo: "Make a purchase and upload my receipt",
  cta_card_change_image: "Change image",
  cta_card_checkin_code_placeholder: "Check-in code",
  cta_card_keyword_1: "Keyword 1",
  cta_card_keyword_2: "Keyword 2",
  cta_card_keyword_3: "Keyword 3",
  cta_card_ocr_detected_amount: "Detected Amount",
  cta_card_ocr_detected_datetime: "Detected Date & Time",
  cta_card_ocr_found: "✓ Found in receipt",
  cta_card_ocr_not_found: "✗ Not found in receipt",
  cta_card_receipt_keywords_instruction:
    "Enter up to 3 keywords that uniquely identify your receipts.",
  cta_card_test_receipt_ocr: "Test a receipt",
  cta_card_tooltip_bao:
    "The goal of this call to action is to distribute as many prize vouchers as possible to your customers' friends, who are likely your best target. Your customers will enjoy offering a prize to their friends by sending them a link via their preferred channel (Whatsapp, SMS, etc.).",
  cta_card_tooltip_checkin:
    "It’s like stamping a loyalty card, except the customer will need to have their QR code scanned by your staff to validate their visit. The validation can be done with any smartphone using a 4-digit code that only your staff will know.",
  cta_card_tooltip_receipt:
    "With this call to action, your customers must prove they made a purchase by photographing their receipt. We will automatically detect that the photo was taken at your establishment using your specific information (SIREN, SIRET, VAT number, phone number).",
  cta_card_tooltip_share:
    "This sharing call to action will help you get known by having your customers share your game room using their preferred channel (Whatsapp, SMS, etc.). The same games and winning chances apply, but with adapted calls to action for a discovery journey.",
  cta_card_tooltip_whatsappgroup:
    "Create a WhatsApp group and paste the link here to encourage your customers to join it. Here’s how to find the link:",
  cta_card_tooltip_whatsappgroup_1: "1. Go to your WhatsApp group.",
  cta_card_tooltip_whatsappgroup_2: "2. Click on the name of the group",
  cta_card_tooltip_whatsappgroup_3:
    "3. Click on “Add people” and then on “Invite to the community via a link.”",
  cta_card_tooltip_whatsappgroup_4: "4. Paste the link here",
  cta_card_upload_receipt_image: "Click to upload a receipt image",
  cta_card_whatsapp_group_link_placeholder:
    "WhatsApp group link (e.g. https://chat.whatsapp.com/...)",
  cta_checkin: "Stamp my visit",
  cta_custom_button_text_placeholder: "Custom text (optional)",
  cta_custom_form: "Custom form",
  cta_custom_form_contact_team: "Contact our team to edit this call-to-action",
  cta_customer_of_month_reward: "Customer of the month reward",
  cta_disabled_bea:
    "You have disabled email authentication, so you cannot enable this action",
  cta_discover_website: "Visit a website",
  cta_download_app: "Download our app",
  cta_editor_heading_2: "One-shot actions",
  cta_editor_heading_3: "Repeatable actions",
  cta_editor_paragraph_2:
    "Encourage your customers to take actions that will boost your Google Maps listing, your social media, etc.",
  cta_facebook_like: "Like Facebook page",
  cta_follow_snapchat: "Follow on Snapchat",
  cta_follow_tiktok: "Follow on TikTok",
  cta_give_birth_date: "Enter your date of birth",
  cta_give_feedback_title: "Give feedback",
  cta_instagram_check_out: "Follow on Instagram",
  cta_instagram_story: "Make a story on Instagram",
  cta_leave_first_name: "Enter your first name",
  cta_leave_phone: "Enter your phone number",
  cta_leave_postal_code: "Enter your postal code",
  cta_leave_review: "Leave a review on Google",
  cta_lets_meet: "Let's get to know each other!",
  cta_link_fields_placeholder: "https://yourwebsite.com",
  cta_link_fields_placeholder_android_playstore:
    "Android Play Store link (e.g. https://play.google.com/store/apps/details?id=com.example.app)",
  cta_link_fields_placeholder_ios_appstore:
    "iOS AppRouterWrapper Store link (e.g. https://apps.apple.com/app/id123456789)",
  cta_link_fields_placeholder_tripadvisor:
    'Link to your "Write a review" page on TripAdvisor',
  cta_loyalty_reward: "Loyalty reward",
  cta_newsletter_subscribe: "Subscribe to newsletter",
  cta_photo: "Photo",
  cta_place_online_order: "Place an online order",
  cta_play_with_friends: "Invite a friend to play",
  cta_rate_1_to_10: "Rate us",
  cta_rate_deliveroo: "Rate on Deliveroo",
  cta_rate_ubereats: "Rate on UberEats",
  cta_rate_ubereats_or_deliveroo: "Rate on UberEats or Deliveroo",
  cta_send_gift_card: "Send a prize voucher to a friend",
  cta_simulate_performance: "Simulate your game performance",
  cta_sponsor_friend: "Refer a friend",
  cta_tripadvisor_review: "Leave a review on TripAdvisor",
  cta_visualize_location: "View location (referrals)",
  cta_whatsapp_group: "Join Whatsapp group",
  cta_whatsapp_hello: "Say hello on WhatsApp!",
  currency: "Currency",
  custom: "Custom",
  custom_quote: "Custom quote",
  custom_str: "Custom",
  customerUpdateError: "Unable to update customer",
  dashboard: "Metrics",
  dashboard_detail: "Dashboard",
  data: "Data",
  data_protection_agreement: "Data Protection Agreement",
  date: "Date",
  date_and_hour: "Date and hour",
  date_format_abbreviated: "MMM DD, YYYY",
  date_format_between: "between {{startDate}} and {{endDate}}",
  date_format_datepicker: "MM/dd/yyyy",
  date_format_full_date: "MM/DD/YYYY",
  date_format_full_with_time: "MM/DD/YYYY HH:mm",
  date_format_month_only: "MMMM",
  date_format_month_year: "MMMM YYYY",
  debug_text_debug: "Debug",
  default_redeem_condition: "Subject to purchase",
  delete_account: "Delete account",
  delete_card: "Delete card",
  deliverer_will_call:
    "Delivery companies will call this number if there's a problem.",
  deliveryContactLabel: "Delivery contact",
  deliveryContactPhoneLabel: "Delivery contact phone number",
  deliveryInfoPlaceholder: "Delivery information",
  describe_your_need: "Describe your need",
  description_required: "Description is required",
  discover_highlights_ideas:
    "💡Discover game ideas for your key marketing moments",
  display_currency: "Average basket currency",
  display_date_format: "MM-DD-YYYY",
  display_dates: "Display those dates",
  distribution: "Distribution",
  do_not_validate: "Refuse",
  downgrade_blocked_message:
    "A sales representative will contact you shortly to find a solution that suits you.",
  downgrade_blocked_title: "This action is not authorized ⚠️",
  downgrade_contact_confirmed_message:
    "Your contact information has been received",
  downgrade_contact_confirmed_title: "All set!",
  downgrade_request_acknowledged_message:
    "A member of our team will contact you shortly",
  download: "Download",
  download_logo: "Upload your logo",
  download_posa_text:
    "In what format would you like to download your promotional material?",
  download_your_materials: "Download your material",
  dpaURL:
    "https://s3.eu-west-3.amazonaws.com/cadeaudelamaison.com/kadow/pdf/SAS_Toot_Sweet_Kadow_Club_Data_Processing_Agreement_DPA_en.pdf",
  dpa_text_1: "I accept the ",
  dpa_text_2: "Data Protection Agreement (DPA)",
  draft: "Draft",
  drive_to_store_legend: "Drive to store",
  edit_place_name: "Edit name",
  edit_your_posa: "Edit your promotional material",
  email: "Email",
  emailLabel: "Email",
  email_content: "Email content",
  email_invalid_format: "Invalid email format",
  email_required: "Email is required",
  emails_and_numbers: "Opt-in",
  emoji_category_activities: "Activities",
  emoji_category_animals_nature: "Animals & Nature",
  emoji_category_flags: "Flags",
  emoji_category_food_drink: "Food & Drink",
  emoji_category_objects: "Objects",
  emoji_category_recent: "Recent",
  emoji_category_smileys: "Smileys",
  end_date: "End",
  enter_internal_name: "Internal name (e.g. outlet number)",
  enter_public_name: "Name displayed to your customers",
  enterprise: "Enterprise",
  err_NoSuchPlan: "This plan does not exist",
  err_Unauthorized: "Unauthorized access",
  error: "Error",
  errorAlert: "Error",
  errorTitle: "Error",
  error_account_not_exist: "This account does not exist",
  error_connection_impossible: "Connection impossible",
  error_connection_link_expired: "The connection link has expired",
  error_connection_link_malformed:
    "The connection link is incorrect or malformed",
  error_creating_venue: "Failed to create new venue. Please try again.",
  error_failed_fetch_neutre_event: "Failed to fetch neutral event:",
  error_general_message: "Error",
  error_generic: "An error occurred. Please try again.",
  error_legacy_backend_failed:
    "Failed to create order. Please contact support.",
  error_no_svg_element: "No SVG element found",
  error_occurred_please_retry: "An error occurred. Please try again.",
  error_pdf_generation_failed: "Failed to generate PDF file. Please try again.",
  error_promo_code_already_used: "This promo code has already been used.",
  error_promo_code_expired: "This promo code has expired",
  error_promo_code_malformed: "This promo code is invalid or malformed",
  error_promo_code_not_authorized:
    "This free license is not authorized for your account. Please contact your sales representative.",
  error_promo_code_not_exist: "This promo code does not exist",
  error_promo_code_plan_mismatch:
    "This promo code is not valid for this plan. Please select the correct plan or use a different promo code.",
  error_quote_already_used: "This quote has already been used.",
  error_quote_no_longer_valid: "This quote is no longer valid.",
  error_s3_upload_failed: "Failed to upload file to server. Please try again.",
  error_updating_place_name: "Error updating place name",
  error_validation_failed: "Failed to validate order. Please contact support.",
  error_verification_code_incorrect: "The verification code is incorrect",
  error_with_code: "{{message}} ({{code}})",
  establishment: "Establishment",
  establishmentTableHeader: "Name",
  event_display_from: "Displayed from",
  event_display_to: "to",
  expired: "Expired",
  expiry_delay_12_hours: "12 hours",
  expiry_delay_12_months: "12 months",
  expiry_delay_1_day: "1 day",
  expiry_delay_1_month: "1 month",
  expiry_delay_1_week: "1 week",
  expiry_delay_2_months: "2 months",
  expiry_delay_2_weeks: "2 weeks",
  expiry_delay_3_months: "3 months",
  expiry_delay_3_weeks: "3 weeks",
  expiry_delay_6_months: "6 months",
  expiry_delay_disabled: "Disabled",
  explanatory_video: "Watch the explanatory video",
  facebookIdHelpText: "Where to find the numeric ID of my Facebook page?",
  facebookIdInstructions:
    "To find the numeric ID of your Facebook page, please follow these steps:",
  facebookIdModalTitle: "Where to find the numeric ID of my Facebook page?",
  facebookIdStep1: "Go to your page",
  facebookIdStep2: 'Go to "About"',
  facebookIdStep3:
    "At the bottom of the page, you will see your numeric ID displayed",
  facebookPageIdStatus: "Facebook page identifier",
  feedback: "Feedback",
  feedbacks: "Feedbacks",
  field_required: "Required",
  finish: "Finish",
  first_payment_will_take_place:
    "The first payment will be made on the specified start date",
  follow_up_scenario: "Follow-up scenario",
  form_button_add: "Add",
  form_button_modify: "Modify",
  form_button_save: "Save",
  form_data: "Form data",
  free: "Free",
  free_license_confirm_button: "Get my free license",
  free_license_description:
    "You are about to activate a free {{planName}} license.",
  free_license_title: "Free License",
  free_trial_confirm_button: "Request a callback",
  free_trial_confirm_message:
    "Our sales team will contact you to verify your eligibility and assist you in setting up your free trial.",
  free_trial_confirm_phone_prompt:
    "Please confirm or correct the phone number we should call:",
  free_trial_confirm_title: "Request a free trial",
  free_trial_request_sent: "Free trial request sent ☑️",
  free_trial_success_message:
    "You will receive a call within the next 48 hours",
  free_trial_success_title: "Your request has been received",
  from: "From",
  full_address: "Full address",
  full_screen_desc:
    "Every time a player scans the QR code, a game in full screen will appear.",
  full_screen_mode: "Full-screen mode",
  game: "Game",
  game_country: "Country where the game will take place",
  game_end_date: "Game end date",
  game_select: "Select",
  game_selected: "Selected ✅",
  game_start_date: "Game start date",
  game_type_3d_dice: "Magic dice",
  game_type_balloon_blast: "Balloon blast",
  game_type_breakout: "Brick Breaker",
  game_type_catcher: "Catcher",
  game_type_fakir_game: "Drop ball game",
  game_type_flip_cards: "Flip cards",
  game_type_jumper: "Jumper",
  game_type_kadow_crush: "Gift Crush",
  game_type_monthly_lottery: "Performance game",
  game_type_mystery_boxes: "Mystery boxes",
  game_type_penalty_kick: "Penalty kicks",
  game_type_prognosis: "Sports prediction",
  game_type_puzzle: "Puzzle",
  game_type_quiz: "Quiz / blind tests trivias",
  game_type_scratch_card: "Scratch card",
  game_type_slot_machine: "Slot machine",
  game_type_space_invaders: "Space Invaders",
  game_type_wheel_of_fortune: "Wheel of fortune",
  game_type_wordle: "Wordle",
  games_and_skins: "Games and skins",
  games_played: "Games played",
  games_redeemed: "Vouchers redeemed",
  games_won: "Games won",
  generate_gift_ideas: "Generate prize ideas",
  generated_revenue: "Generated revenue {{currency}}",
  generic_error: "An error occurred",
  gift: "Prize",
  gift_expiry_delay_label: "Prize expiration delay",
  gift_expiry_reminder_text:
    "We will remind your customers as the prize expiration approaches",
  gift_name_min_characters: "Name must be at least 5 characters",
  gift_name_must_start_with_number:
    'Name must start with a number or number in words (e.g. "1 coffee" or "Three drinks")',
  gift_name_required: "Name is required",
  gift_percentage_placeholder: "% of winners for this prize",
  gift_percentage_sum_exceed:
    "Sum of percentages must not exceed 100% (current total: {{sum}}%)",
  gift_selector_chance_exceed: "Win chances cannot exceed 100%.",
  gift_selector_specify_chance: "Please specify a win chance for each prize.",
  gift_suggestions_description:
    "Here are some prize ideas related to your sector",
  gift_with_name_and_percentage: "{{name}}: {{pc}}%",
  gift_with_position: "Prize {{position}}",
  gift_with_position_and_percentage: "Prize {{position}}: {{pc}}%",
  go_to_ctas_page: "Add calls-to-action",
  go_to_games_page: "Add games",
  go_to_prizes_page: "Add prizes",
  googlePlaceStatus: "Your establishment on Google",
  highlight_date: "From {{startDate}} to {{endDate}}",
  highlight_name: "Highlight",
  iframe_not_supported: "Iframes are not supported.",
  impossible_action: "Not possible",
  incomplete: "Incomplete",
  incomplete_game: "Please finalize your setup to test your game",
  incomplete_game_cta_missing: "Call-to-action: ❌",
  incomplete_game_cta_present: "Call-to-action: ✅",
  incomplete_game_game_missing: "Games: ❌",
  incomplete_game_game_present: "Games: ✅",
  incomplete_game_intro:
    "A minimum of one game, one prize and one call to action configured are required to make your game work. Here's your current status:",
  incomplete_game_prize_missing: "Prize: ❌",
  incomplete_game_prize_present: "Prize: ✅",
  incomplete_game_test_warning_link:
    "⚠️ You can still test the game, but it could be unstable. You can use the link below ⚠️",
  incomplete_game_test_warning_qr:
    "⚠️ You can still test the game, but it could be unstable. You can use the QR code below ⚠️",
  info_delivering_billing_address: "Billing address *",
  info_delivering_billing_country: "Billing country",
  info_delivering_billing_country_placeholder: "Billing country",
  info_delivering_billing_info: "Billing information",
  info_delivering_company_name_placeholder:
    "E.g. Watermelon LLC, Pineapple Inc, etc",
  info_delivering_company_optional: "Company (optional)",
  info_delivering_delivery_contact: "Delivery contact *",
  info_delivering_next: "Next",
  info_delivering_phone_number: "Phone number to contact *",
  info_delivering_previous: "Previous",
  info_delivering_shipping_info: "Shipping information",
  info_delivering_shipping_name_placeholder: "E.g. John Smith",
  info_delivering_shipping_phone_placeholder: "E.g. 555-123-4567",
  instagramLinkPlaceholder: "Link to your Instagram page",
  instagramProfileStatus: "Instagram Profile",
  internal_name: "Internal name",
  invoices: "Invoices",
  jetpackConfigUpdateError: "Unable to update jetpack config",
  jetpack_checkout_form_become_member: "Become a club",
  jetpack_checkout_form_billing_country_placeholder: "Billing country",
  jetpack_checkout_form_club: "member",
  jetpack_checkout_form_company_optional: "Company (optional)",
  jetpack_checkout_form_error_no_promo_code: "No promo code",
  jetpack_checkout_form_error_price_calculation: "Price calculation error",
  jetpack_checkout_form_payment_method: "Payment method",
  jetpack_checkout_form_promo_code: "Promo code",
  jetpack_checkout_form_success_body:
    "We confirm that your {{planName}} licence has been activated.",
  jetpack_checkout_form_success_button: "Explore your {{planName}} pack",
  jetpack_checkout_form_success_header: "Let's go! 🚀",
  jetpack_config_checkin_code_required:
    "The check-in code must consist of 4 digits.",
  jetpack_config_cta_gain_min_error: "A CTA must earn at least 1 token",
  jetpack_config_cta_link_required: "The link is required.",
  jetpack_config_cta_link_validation_error:
    "Please correct your URL link as it doesn't lead anywhere.",
  jetpack_config_cta_test_error: "The link must be defined.",
  jetpack_config_download_pdf: "PDF",
  jetpack_config_download_png: "PNG",
  jetpack_config_google_address_required:
    "Please enter an address to identify your Google page.",
  jetpack_config_ocr_keywords_required:
    "You must provide at least one keyword.",
  jetpack_config_whatsapp_group_link_invalid:
    "The WhatsApp group link must be in the format https://chat.whatsapp.com/XXXXXX",
  jetpack_config_whatsapp_group_link_required:
    "The WhatsApp group link is required.",
  jetpack_onboarding_step_1_title: "Finish your registration",
  jetpack_onboarding_step_2_description:
    "Your games can be modified at any time.",
  jetpack_onboarding_step_2_title: "Choose your games!",
  jetpack_onboarding_step_8_description:
    "You can modify the titles, emojis and winning odds at any time.",
  jp_add_gift_btn_text: "Add a prize",
  jp_default_place_name: "Establishment",
  jp_finalize_button_text: "Finalize my game",
  jp_next_btn_text: "Next step",
  jp_onboarding_description_step_cta:
    "Enter your business' name to setup Google reviews collection in your game.",
  jp_onboarding_form_label_avg_basket: "Average basket",
  jp_onboarding_form_label_clients_per_day:
    "How many clients per day do you have? (Across all points of sale and channels combined: on-site, delivery, etc.)",
  jp_onboarding_form_label_email: "Contact email",
  jp_onboarding_form_label_first_name: "First name",
  jp_onboarding_form_label_last_name: "Last name",
  jp_onboarding_form_label_operational_contact: "Site coordinator name",
  jp_onboarding_form_label_operational_contact_phone: "Phone",
  jp_onboarding_form_label_place_name: "Venue name",
  jp_onboarding_form_label_sector: "Sector",
  jp_onboarding_game_preview_text_1:
    "Access your dashboard to review your setup and choose your promotional materials!",
  jp_onboarding_game_ready_text: "Your game is almost ready",
  jp_onboarding_giftform_generate_ideas: "Generate ideas",
  jp_onboarding_giftform_helper_format:
    "For optimal readability, we recommend the following format: '1 dessert', '1 cocktail', '1 drink'",
  jp_onboarding_giftform_label_percentage: "Winning percentage",
  jp_onboarding_giftform_placeholder_name: "1 dessert",
  jp_onboarding_placeholder_google_place_id:
    "Name and address of your business",
  jp_onboarding_socials_placeholder_facebook:
    "Link to your business Facebook page",
  jp_onboarding_socials_placeholder_instagram:
    "Link to your business Instagram page",
  jp_onboarding_socials_placeholder_snapchat: "Your business Snapchat account",
  jp_onboarding_socials_placeholder_tiktok: "Your business TikTok account",
  jp_onboarding_step_gift_gift_name: "Prize name",
  jp_onboarding_step_gift_gifts_text: "Prize",
  jp_onboarding_step_gift_label_condition: "Redemption conditions",
  jp_onboarding_step_gift_placeholder_condition_01: "Redemption condition 1",
  jp_onboarding_step_gift_placeholder_condition_02:
    "Redemption condition 2 (optional)",
  jp_onboarding_step_gift_placeholder_condition_03:
    "Redemption condition 3 (optional)",
  jp_onboarding_step_gift_toggle_label_condition:
    "Prize redeemable under conditions",
  jp_onboarding_subtitle_step_cta: "Google identifier",
  jp_onboarding_title_step_cta_selector: "Your call to action!",
  jp_onboarding_title_step_gift_selector: "Pre-select 3 to 5 prizes",
  jp_onboarding_title_step_gift_selector_01: "Here are some prize ideas",
  jp_prize_sector_bar_00: "1 portion of fries",
  jp_prize_sector_bar_01: "1 appetizer platter",
  jp_prize_sector_bar_02: "1 cocktail",
  jp_prize_sector_cafe_00: "1 coffee",
  jp_prize_sector_hotel_00: "1 breakfast",
  jp_prize_sector_hotel_01: "1 glass of champagne",
  jp_prize_sector_hotel_02: "-X% off your next stay",
  jp_prize_sector_park_00: "-20% off your next entry",
  jp_prize_sector_park_01: "1 drink",
  jp_prize_sector_park_02: "1 free game",
  jp_prize_sector_restaurant_00: "1 dessert",
  jp_prize_sector_restaurant_01: "1 drink",
  jp_prize_sector_restaurant_02: "1 menu",
  jp_prize_sector_shop_00: "-X% discount",
  jp_prize_sector_shop_01: "1 tote bag",
  jp_prize_sector_shop_02: "1 accessory",
  jp_prize_wellness_00: "1 treatment",
  jp_prize_wellness_01: "1 product",
  jp_prize_wellness_02: "20% discount",
  jp_proceed: "Setup",
  jp_return_btn_text: "Back",
  jp_sector_bar: "Bar",
  jp_sector_cafe: "Cafe",
  jp_sector_hotel: "Hotel",
  jp_sector_park: "Leisure",
  jp_sector_restaurant: "Restaurant",
  jp_sector_shop: "Shop",
  jp_skip_btn_text: "Skip this step →",
  jp_validate_gift_text: "Validate my prizes",
  jp_weekly_quantity_limit_label: "With a weekly quantity limit",
  jp_win_change_desc_00: "Players will have ",
  jp_win_change_desc_01: " chance to win a prize and ",
  jp_win_change_desc_02: " chance to lose",
  jp_win_change_text: "Probability of winning your prizes",
  kc_input_label: "Input label",
  kc_input_placeholder: "Your text here...",
  last: "Last",
  legal: "Legal",
  light: "Light",
  linkPlaceholder: "Link",
  list: "Detailled",
  loading: "Loading...",
  log_in: "Sign in",
  login_hero_text: "Offering a kadow makes you grow",
  logo_size: "Logo size",
  logo_upload_instructions: "PNG, JPEG or WEBP",
  logout: "Logout",
  loss_percentage: "Chances of loosing: {{percentage}}%",
  loyalty: "Loyalty Program",
  loyalty_choose_my_gifts: "Choose my gifts",
  loyalty_customer_of_month_section_title: "Customer of the month prize",
  loyalty_customize_reward: "Customize the reward",
  loyalty_delete_prize_offer_tokens: "Delete this prize and offer game tokens",
  loyalty_disable_confirmation:
    "This will disable your loyalty program. Confirm deletion?",
  loyalty_gifts_configure_leaderboard: "Configure customer of the month",
  loyalty_gifts_configure_tiers: "Configure tier rewards",
  loyalty_gifts_configure_tiers_desc:
    "Set a gift or tokens for each loyalty tier.",
  loyalty_gifts_heading: "Choose your gifts",
  loyalty_leaderboard_disable_confirmation:
    "Your customer of the month will have no reward. Confirm deletion?",
  loyalty_leaderboard_special_prize_desc:
    "These prizes are automatically awarded each month to the customers with the most completed actions.",
  loyalty_leaderboard_special_prize_label: "Leaderboard Special Prize",
  loyalty_leaderboard_tie_warning:
    "In the event of a tie, this prize may be granted to more than one customer.",
  loyalty_leaderboard_top_customer_reward_desc:
    "Reward for the customer or customers with the highest number of actions each month",
  loyalty_prizes_section_description:
    "These prizes are automatically awarded to customers who unlock badges based on the number of actions performed.",
  loyalty_prizes_section_title: "Loyalty prizes",
  loyalty_threshold_actions: "{{count}} action",
  loyalty_threshold_actions_plural: "{{count}} actions",
  loyalty_tokens_count: "{{count}} tokens",
  ma_birthday: "Birthday",
  ma_birthday_desc: "Token awarded on the player's birthday",
  ma_loyalty_customer_of_the_month_desc:
    "Email sent on the 1st of the month to all customers ranked at the top of the Customer of the Month leaderboard.",
  ma_loyalty_customer_of_the_month_title: "Customer of the Month",
  ma_reminder: "Winning reminder",
  ma_reminder_desc:
    "Three emails sent before expiration, reminding a person that they have won a gift.",
  ma_tokens_offered: "Tokens offered",
  ma_tokens_offered_desc: "On the 15th of each month",
  ma_welcome_email: "Welcome email",
  ma_welcome_email_desc: "D+3 after registration",
  mandatory: "Mandatory",
  marketing_automation_lottery_loss_description:
    "On the day of a jackpot draw. You cannot disable this scenario.",
  marketing_automation_lottery_loss_title: "Pooled prize lost",
  marketing_automation_lottery_win_description:
    "On the day of a jackpot draw. You cannot disable this scenario.",
  marketing_automation_lottery_win_title: "Pooled prize won",
  marketing_automation_scenario_cannot_be_disabled_message:
    "This scenario cannot be disabled",
  marketing_automation_scenario_cannot_be_disabled_title:
    "Cannot disable scenario",
  marketing_automation_win_email_description:
    "When a player wins a prize. You cannot disable this scenario.",
  marketing_automation_win_email_title: "Win email",
  max_characters: "Must be at most {{n}} characters",
  means_of_payment: "Means of payment",
  min_characters: "Must be at least {{n}} characters",
  ml_configure_title: "Setup your big prizes",
  ml_monthly_prizes: "Monthly big prizes",
  ml_monthly_prizes_desc:
    "Take advantage of ready-made Kadow Club big prizes with one click",
  ml_prize_type_subtitle: "Type of big prizes to offer to your players",
  modify_avg_basket: "Modify my average basket ({{avgBasket}})",
  modify_avg_basket_formula_text:
    "Calculation formula: [number of prizes given] x [average basket = {{avgBasket}}] x 1.5 (accompanying persons) + sum of the amount of all receipts",
  modify_avg_basket_modal_description:
    "Enter your average basket amount in {{currency}}.",
  modify_avg_basket_modal_helper_text:
    "This value will be used to calculate the estimated business revenue.",
  modify_avg_basket_modal_input_placeholder: "Amount in €",
  modify_avg_basket_modal_title: "Modify my average basket",
  modify_emoji: "Modify emoji",
  money_sigle: "$",
  monthFromLabel: "From",
  monthly_ht: "Monthly",
  monthly_lottery: "Pooled grand prizes",
  monthly_lottery_description:
    "These big prizes appear next to yours to get your customers dreaming! (Draw held on the 1st of every month)",
  monthly_performance_reports: "Monthly Performance Reports",
  monthly_statistics: "Monthly reports",
  monthly_stats_back_button: "← Back",
  monthly_stats_birthdays_collected: "birth dates collected",
  monthly_stats_boost_message:
    "In {{monthText}}, Kadow club boosted your business by {{amount}} 🚀",
  monthly_stats_check_in: "check-ins",
  monthly_stats_emails_collected: "emails collected",
  monthly_stats_estimated_value_header: "Estimated value ({{currency}})",
  monthly_stats_estimation_method_header: "Estimation method",
  monthly_stats_facebook_actions: "Facebook actions",
  monthly_stats_gifts_redeemed_plural: "prizes redeemed",
  monthly_stats_gifts_redeemed_singular: "prize redeemed",
  monthly_stats_google_actions: "Google review actions",
  monthly_stats_instagram_actions: "Instagram actions",
  monthly_stats_new_sponsored_customers_plural: "new customers from referrals",
  monthly_stats_new_sponsored_customers_singular: "new customer from referrals",
  monthly_stats_new_visits_calculation:
    "New visits x average basket ({{avgBasket}}) x {{multiplier}} (to include accompanying persons)",
  monthly_stats_no_communication_materials:
    "It seems that your communication materials were not in place this month",
  monthly_stats_no_players:
    "You will have access to reports at the end of each month as soon as your game is launched.",
  monthly_stats_per_action: "{{amount}} / action",
  monthly_stats_per_birthday: "{{amount}} / birth date",
  monthly_stats_per_checkin: "{{amount}} / check-in",
  monthly_stats_per_email: "{{amount}} / email address",
  monthly_stats_per_number: "{{amount}} / number",
  monthly_stats_per_sponsorship: "{{amount}} / referral",
  monthly_stats_phones_collected: "phone numbers collected",
  monthly_stats_receipts_scanned: "receipts scanned",
  monthly_stats_receipts_scanned_amounts: "Scanned amounts",
  monthly_stats_results_header: "Results for {{monthText}}",
  monthly_stats_sponsored_authentications_plural: "referrals",
  monthly_stats_sponsored_authentications_singular: "referral",
  monthly_stats_total: "Total",
  months: "{{duration}} months",
  must_be_number_for_token: "The number of tokens must be an integer",
  must_enter_shipping_address:
    "You must provide a shipping address for {{placeName}} before validating your artwork.",
  my_account: "My account",
  name: "Name",
  needs_redesign: "Redesign",
  new_venue_add: "Add a licence",
  new_venue_add_1: "Add a",
  new_venue_add_2: "licence",
  new_venue_no_accounts_available: "No accounts available",
  new_venue_same_legal_entity_no: "No, it's a different legal entity",
  new_venue_same_legal_entity_yes: "Yes",
  new_venue_select_account: "Select an account",
  new_venue_select_plan: "Select a subscription plan",
  new_venue_step1_title: "Is it the same legal entity as an existing licence?",
  next: "Next",
  next_step_button: "Next step",
  no: "No",
  noActiveSubscriptionsMessage: "No subscriptions.",
  noTokenAlert: "No token",
  no_card_subscription_description:
    "You are about to subscribe to the {{planName}} plan. No payment card is required during the free month.",
  no_card_subscription_description_2:
    "If you decide to keep the product, you can enter your credit card details at any time during the free trial.",
  no_data: "No data in this date range",
  no_invoices: "No invoices for this venue.",
  no_saved_payment_methods: "No saved cards",
  none: "none",
  none_feminine: "None.",
  notFoundMessage:
    "Oops! The page you are looking for does not exist or has been moved.",
  notImplementedAlert: "Not implemented",
  not_applicable: "N/A",
  numberOfTablesLabel: "Number of tables",
  numericIdPlaceholder: "Numeric identifier",
  ocr_legend: "Scanned receipt ",
  of: "of",
  ok: "OK",
  okButton: "OK",
  onboarding_choose_ctas_longtitle:
    "Your calls-to-action are the actions that will be requested from players before playing.",
  onboarding_choose_ctas_name: "Calls-to-action",
  onboarding_choose_ctas_title: "Choose your calls-to-action",
  onboarding_choose_distribution_name: "Promotional materials",
  onboarding_choose_distribution_title: "Choose your distribution channels",
  onboarding_choose_emails_longtitle:
    "Stay in touch with your customers automatically and let them play from home so they never forget you.",
  onboarding_choose_emails_name: "Automated emails",
  onboarding_choose_emails_title: "Choose your automated email sequences",
  onboarding_choose_gifts_longtitle:
    "These are the prizes you will give to the winners.",
  onboarding_choose_gifts_name: "Prizes",
  onboarding_choose_gifts_title: "Choose your prizes",
  onboarding_logo_and_colors_name: "Logo and colors",
  onboarding_logo_and_colors_title: "Logo and colors",
  onboarding_select_games_longtitle:
    "We offer several types of games among the most popular.",
  onboarding_select_games_name: "Games",
  onboarding_select_games_title: "Select your games",
  onboarding_settings: "Settings",
  onlinePOSAGallery_template_step1: "Personalize and download a template",
  onlinePOSAGallery_template_step2: "Upload it to your social network page",
  onlinePOSAGallery_template_step3: "Insert the link to the game",
  onlinePOSAGallery_template_step4: "Publish your game",
  online_posa_copy_link:
    "Copy the link to share it on your social media or online campaigns",
  online_posa_gallery_title: "Our tips for promoting your game online 🎲",
  online_posa_ig_post: "Instagram Post",
  online_posa_ig_story: "Instagram Story",
  online_posa_templates_heading: "Discover templates for your Insta stories",
  open_pdf: "Open document",
  optins: "OptinsTable",
  order_summary_advanced_email_sequences: "advanced email sequences",
  order_summary_all_actions: "all actions",
  order_summary_annual: "Yearly",
  order_summary_calls_to_action: "{{count}} call(s) to action",
  order_summary_custom_communication_materials: "custom promotional materials",
  order_summary_custom_logo_and_colors: "custom logo and colors",
  order_summary_discount: "Discount ({{percent}} %)",
  order_summary_free_month: "Free trial start (1 month)",
  order_summary_from: "From ",
  order_summary_games_of_chance: "games of chance",
  order_summary_monthly: "Monthly",
  order_summary_monthly_jackpots: "monthly jackpots",
  order_summary_monthly_payment_post_tax: "Total incl. tax",
  order_summary_monthly_payment_pre_tax: "Total excl. tax",
  order_summary_order: "Order",
  order_summary_pack_enterprise: "Pack enterprise",
  order_summary_pack_premium: "Pack Premium",
  order_summary_performance_games: "performance games",
  order_summary_starting_next_month: "Starting next month: ",
  order_summary_themed_skins: "themed skins",
  order_summary_this_month: "This month: ",
  order_summary_to: " to ",
  order_summary_total_post_tax: "Total incl. tax",
  order_summary_total_pre_tax: "Total excl. tax",
  order_summary_vat: "Tax ({{percent}})",
  ordinal_suffix_eme: "ème",
  ordinal_suffix_ere: "ère",
  ordinal_suffix_nd: "nd",
  ordinal_suffix_rd: "rd",
  ordinal_suffix_st: "st",
  ordinal_suffix_th: "th",
  other: "Other",
  other_supports: "Other supports",
  pack_label: "Pack",
  page: "Page",
  paid: "Paid",
  participation: "action",
  participation_distribution: "Unique players by number of participations",
  password: "Password",
  pay: "Pay",
  pay_amount: "Pay {{amount}}",
  pay_amount_subscription: "Subscribe",
  pay_bill_button: "Pay {{amount}}",
  pay_bill_modal_title: "Pay Bill",
  pay_bill_posa_success_message:
    "Your bill has been paid successfully, and your order was sent to print!",
  pay_bill_success_message: "Your bill has been paid successfully!",
  pay_bill_success_title: "Payment Successful",
  payable_from_date: "After your free, no obligation trial month",
  paymentServerError: "Payment server error",
  payment_done_modal_button_text: "OK",
  payment_done_modal_text: "Your order has been sent to print.",
  payment_done_modal_title: "Payment made!",
  payment_error_generic:
    "We couldn't process your payment at this time. Please contact our support team.",
  payment_error_title: "Payment Unsuccessful",
  payment_in_progress: "Automatic payment in progress",
  payment_transaction_ongoing: "Transaction ongoing",
  pdf_mobile_explanation:
    "Click on the button at the bottom of the screen to view the PDF document.",
  percentage_validation: "The minimum percentage must be between 0 and 100",
  period: "Period",
  period_shortcut_1_day: "1 day",
  period_shortcut_1_month: "1 month",
  period_shortcut_2_weeks: "2 weeks",
  period_shortcut_3_months: "3 months",
  period_shortcut_6_months: "6 months",
  personalize: "Customize",
  phone_invalid_format: "Invalid phone format",
  phone_label: "Phone *",
  phone_number: "Phone number",
  phone_placeholder_french: "06xxxxxxxx or 07xxxxxxxx",
  phone_required: "Phone is required",
  place: "Place",
  placeholder_shipping_address: "Type an address",
  plan_discount_saved: "{{percentage}}% saved!",
  plan_discount_yearly_save:
    "Save {{percentage}}% by choosing the annual subscription",
  plan_option_current_plan: "Current plan ✅",
  plan_option_monthly_ht: "/ month",
  plan_option_quote: "Quote",
  plan_option_request_quote: "Request a quote",
  player_activity: "Player activity",
  posa_artwork_issue: "Artwork issue",
  posa_canceled: "Canceled",
  posa_carrier_update: "Carrier update",
  posa_category_at_counter: "At the counter",
  posa_category_at_counter_display: "At the counter",
  posa_category_at_table: "At table",
  posa_category_at_table_display: "At table",
  posa_category_delivery_bags: "With delivery bags",
  posa_category_delivery_bags_display: "With delivery bags",
  posa_category_establishment: "In the establishment",
  posa_category_establishment_display: "In the establishment",
  posa_category_hand_to_hand: "Hand to hand",
  posa_category_hand_to_hand_display: "Hand to hand",
  posa_category_point_of_sale: "At the point of sale",
  posa_category_point_of_sale_display: "At the point of sale",
  posa_category_reception_common: "At reception and common areas",
  posa_category_reception_common_display: "At reception and common areas",
  posa_category_reprint_existing: "By reprinting existing materials",
  posa_category_reprint_existing_display: "By reprinting existing materials",
  posa_category_rooms: "In the rooms",
  posa_category_rooms_display: "In the rooms",
  posa_category_social_media: "Via social media",
  posa_category_social_media_display: "Via social media",
  posa_category_table: "At the table",
  posa_category_table_display: "At the table",
  posa_delivered: "Delivered",
  posa_delivered_at_neighbours: "Delivered to neighbours",
  posa_delivered_at_pickup_point: "Delivered at pickup point",
  posa_delivery_failed: "Delivery failed",
  posa_download_qr_code: "Download QR code",
  posa_flyer_a5: "A5 flyer (14.8x21 cm)",
  posa_flyer_a6: "A6 flyer (10.5x14.8 cm)",
  posa_form_activity_question: "What is your activity?",
  posa_form_delivery_bag_supports_question:
    "To communicate via your delivery bags, you prefer:",
  posa_form_delivery_clients_per_day:
    "How many delivery / take away customers do you have per day?",
  posa_form_delivery_no_game: "I don't want to engage my delivery customers",
  posa_form_delivery_print_on_bag: "Delivery bags",
  posa_form_delivery_service_question: "Delivery / takeaway",
  posa_form_delivery_staple_business_card: "Staple a gift card",
  posa_form_delivery_staple_flyer: "Staple an A6 flyer",
  posa_form_delivery_stick_sticker: "Stick a sticker on each bag",
  posa_form_dine_in_service_question: "Dine-in service",
  posa_form_establishment_none: "I don't want any of these at my venue",
  posa_form_establishment_poster_a2: "A2 poster",
  posa_form_establishment_sticker_dome: "Dome sticker 7.5 x 7.5 (recommended)",
  posa_form_establishment_sticker_rond: "Round sticker 10 x 10",
  posa_form_establishment_support_question:
    "Within your venue, which promotional material do you prefer to install?",
  posa_form_items_selected: "{{count}} item selected",
  posa_form_items_selected_plural: "{{count}} items selected",
  posa_form_none: "None",
  posa_form_preview_delivery_bag_flyer_a6:
    "Print {{quantity}} A6 flyers (10.5 x 14.8 cm) and staple them on your delivery bags",
  posa_form_preview_delivery_bag_presence:
    "☑️ Make sure your game is on all your delivery bags",
  posa_form_preview_delivery_bag_stickers10x10:
    "Order {{quantity}} stickers (10 x 10 cm) and stick them on all your delivery bags",
  posa_form_preview_establishment: "☑️ Promote your game in your venue",
  posa_form_preview_hand_to_hand: "☑️ Spread the game hand to hand",
  posa_form_preview_hand_to_hand_description:
    "Print {{quantity}} gift cards (business card format) and hand them to your customers on arrival or departure",
  posa_form_preview_reprint_supports:
    "☑️ Reprint materials that are part of your environment",
  posa_form_preview_reprint_supports_description:
    "Please upload the materials in which you would like us to integrate your game and QR code, in an editable format (ai, .indd, .pdf, canva). You will receive our visual proposals by email in the next days.",
  posa_form_preview_table_presence:
    "☑️ Make sure your game is always visible on your tables",
  posa_form_preview_table_presence_flyer_a5:
    "Print at least {{quantity}} A5 flyers (14.8 x 21 cm) double-sided and place them in table tents on all your tables",
  posa_form_preview_table_presence_flyer_a6:
    "Print at least {{quantity}} A6 flyers (10.5 x 14.8 cm) double-sided and place them in table tents on all your tables",
  posa_form_preview_table_presence_stickers_dome:
    "Order at least {{quantity}} dome stickers (7.5 x 7.5) and stick them on all your tables",
  posa_form_preview_title: "Our tips for promoting your game in store 🏆",
  posa_form_retake: "Retake the form",
  posa_form_status_created: "Sent to our designer",
  posa_form_status_done: "Done",
  posa_form_status_in_progress: "In progress",
  posa_form_status_pending_am: "In progress",
  posa_form_status_pending_client: "Ready for review",
  posa_form_status_rejected_by_team: "Rejected by team",
  posa_form_status_resent: "In progress",
  posa_form_support_packaging_imprimables: "Printable packaging",
  posa_form_support_sac_livraison: "Delivery bag",
  posa_form_table_how_many: "How many tables do you have?",
  posa_form_table_no_game: "I don't want to engage my dine-in customers",
  posa_form_table_stickers10x10: "Round sticker 10 x 10",
  posa_form_table_stickers_dome: "Dome sticker 7.5 x 7.5 (recommended)",
  posa_form_table_supports_question:
    "Which promotional material seems most suitable for your tables?",
  posa_form_title: "Customized recommendation form ✏️",
  posa_form_upload_support: "Upload",
  posa_form_view_result: "View result",
  posa_form_which_supports_do_you_use: "Which of these materials do you use?",
  posa_format_a_long: "Gift card (21x7.4 cm)",
  posa_format_a_long_desc:
    "Presented at the same time as the bill or invoice, it creates a surprise effect and prolongs the customer experience. A simple gesture that makes people want to try their luck!",
  posa_format_businesscardsstandard_desc: "",
  posa_format_chevalet_a5_desc:
    "Placed on tables or at the counter, it provides optimal visibility of the game to your customers. An elegant format that catches the eye without taking up space!",
  posa_format_chevalet_a6_desc:
    "Compact and discreet, it fits perfectly on your tables or counters to remind your customers of the game effortlessly.",
  posa_format_flyer_a5_desc:
    "Attached directly to your bags, it ensures that every customer leaves with the game information right in front of them. It can also be distributed to your customers or used for customer acquisition purposes. Simple, economical, and effective!",
  posa_format_flyer_a6_desc:
    "Attached directly to your bags, it ensures that every customer leaves with the game information right in front of them. It can also be distributed to your customers or used for customer acquisition purposes. Simple, economical, and effective!",
  posa_format_stickers10x10_desc:
    "A true Swiss Army knife, it adapts to all your needs: stick it on a bag, menu, package, or even a storefront window—a flexible medium for promoting the game wherever you want.",
  posa_format_stickers_dome_desc:
    "With its curved, shiny finish, it's a real eye-catcher. Durable and elegant, it's sure to be a hit!",
  posa_gallery_description:
    "Print your communication materials or take advantage of our negotiated rates.",
  posa_item_a4_counter_display: "A4 counter display",
  posa_item_a4_counter_display_display: "A4 counter display",
  posa_item_a4_display: "A4 table stand",
  posa_item_a4_display_display: "A4 table stand",
  posa_item_a5_display: "A5 table stand",
  posa_item_a5_table_tent_display: "A5 table tent",
  posa_item_a6_display: "A6 table stand",
  posa_item_a6_display_display: "A6 table stand",
  posa_item_a6_flyer: "A6 flyer",
  posa_item_a6_flyer_display: "A6 flyer",
  posa_item_a6_table_tent: "A6 table tent",
  posa_item_a6_table_tent_display: "A6 table tent",
  posa_item_bag_printing: "Bag printing",
  posa_item_bag_printing_display: "Bag printing",
  posa_item_business_card: "Gift card (business card format)",
  posa_item_business_card_display: "Business card",
  posa_item_coasters: "Coasters",
  posa_item_coasters_display: "Coasters",
  posa_item_dome_sticker: "Dome sticker (recommended)",
  posa_item_dome_sticker_display: "Dome sticker (recommended)",
  posa_item_gift_card: "Gift card",
  posa_item_gift_card_display: "Gift card",
  posa_item_kakemono: "Kakemono (85 x 200 cm)",
  posa_item_kakemono_display: "Kakemono",
  posa_item_other_printable: "Other printable support",
  posa_item_other_printable_display: "Other printable support",
  posa_item_paper_menu: "Paper menu",
  posa_item_paper_menu_display: "Paper menu",
  posa_item_placemat: "Placemat (recommended)",
  posa_item_placemat_display: "Placemat (recommended)",
  posa_item_post_format: "Post format",
  posa_item_post_format_display: "Post format",
  posa_item_poster: "Poster",
  posa_item_poster_a2: "A2 poster (420 x 594 mm)",
  posa_item_poster_a3: "A3 poster (297 x 420 mm)",
  posa_item_poster_a4: "A4 poster (210 x 297 mm)",
  posa_item_poster_display: "Poster",
  posa_item_shelf_stopper: "Shelf stopper",
  posa_item_shelf_stopper_display: "Shelf stopper",
  posa_item_stapled_a6_flyer: "Stapled A6 flyer",
  posa_item_stapled_a6_flyer_display: "Stapled A6 flyer",
  posa_item_stapled_flyer: "Stapled flyer",
  posa_item_stapled_flyer_display: "Stapled flyer",
  posa_item_sticker: "Sticker",
  posa_item_sticker_display: "Sticker",
  posa_item_story_format: "Story format",
  posa_item_story_format_display: "Story format",
  posa_item_welcome_booklet: "Welcome booklet",
  posa_item_welcome_booklet_display: "Welcome booklet",
  posa_item_window_sticker: "Sticker",
  posa_item_window_sticker_display: "Sticker",
  posa_list_next: "Discover my recommended materials",
  posa_list_previous: "Previous",
  posa_list_quantity: "Quantity",
  posa_list_quantity_required: "You must choose quantities for each material",
  posa_list_selected_supports: "Selected materials",
  posa_list_total_ht: "Total HT",
  posa_list_total_ttc: "Total TTC",
  posa_list_total_ttc_label: "Total TTC  ",
  posa_list_type: "Type",
  posa_list_unit_price: "Unit price",
  posa_list_units: "{{qty}} unit{{s}} - {{price}} HT",
  posa_list_unknown: "Unknown",
  posa_mode_offline: "In-store",
  posa_mode_online: "Online",
  posa_model: "{{templateName}} template",
  posa_must_pay_before_validate:
    "This order must be paid by card before proceeding with validation.",
  posa_ongoing_printing: "Orders in progress",
  posa_onsite: "On site",
  posa_order_date: "Order date",
  posa_past_artwork: "Past orders",
  posa_preparing: "In design stage",
  posa_preview_modal_title: "Visual proposal for validation",
  posa_printing_ongoing: "In printing stage",
  posa_quantity_default: "some",
  posa_shipped: "Shipped",
  posa_short: "Materials",
  posa_sticker: "Standard stickers (10x10 cm)",
  posa_sticker_dome: "Doming stickers (7.5x7.5 cm)",
  posa_takeaway: "Takeaway",
  posa_template: "{{template}} template",
  posa_to_ship: "Ready for shipping",
  posa_to_validate_explanation_text:
    "The below orders are awaiting your validation and your payment.",
  posa_validate_artwork_title: "Artwork validation",
  posa_validate_explanation:
    "If you're satisfied with this artowrk, click the '{{validate_button_text}}' button. If not, leave a comment and click the '{{do_not_validate_button_text}}'",
  posa_wording_burger: "Burger",
  posa_wording_cadeau: "Prize",
  posa_wording_cocktail: "Cocktail",
  posa_wording_iphone: "iPhone",
  posa_wording_label: "Displayed prize",
  posa_wording_pizza: "Pizza",
  posa_wording_plat: "Dish",
  posa_wording_plats_boissons: "Food & drinks",
  posa_wording_repas: "Meal",
  posa_wording_sejour: "Free stay",
  premium: "Premium",
  premium_plus: "Premium +",
  previous: "Previous",
  prize: "Prize",
  prize_name_max_characters: "Prize name cannot exceed {{count}} characters",
  prizes_configurator_choose_my_prize: "Setup my prize",
  prizes_configurator_choose_my_prizes: "Setup my prizes",
  prizes_configurator_max_per_week: ", max {{quantity}}/week",
  prizes_configurator_my_prizes: "Prizes in your game",
  prizes_configurator_no_name_gift: "Unnamed prize ",
  prizes_configurator_see_video: "Watch video",
  prizes_configurator_text_about_prizes:
    "Create irresistible prizes that keep your customers playing — and coming back!",
  profile_billing_country: "Billing country",
  profile_company_name: "Company name",
  profile_timezone: "Timezone",
  promoCodeAppliedMessage: "The promo code is applied!",
  promoCodePlaceholder: "Enter your promo code...",
  public_name: "Public name",
  public_posa_modal_price: "Price (excl. tax)",
  public_posa_modal_quantity: "Quantity",
  public_posa_modal_title_prefix: "Prices for",
  public_posa_page_heading: "Public prices for promotional materials",
  public_posa_page_subheading:
    "These prices are subject to change and are updated every hour.",
  public_posa_table_name: "Name",
  public_posa_table_photos: "Photos",
  public_posa_table_price: "Price",
  public_posa_table_price_list: "Price list",
  public_price_ht: "Public price",
  public_prices_guarantee_text:
    "* The guarantee applies provided that our recommendations for promoting the game are followed — that is, at least two fixed communication supports (e.g., stickers, print on bags, etc.) and at least one hand-to-hand support (e.g., gift card, flyer, etc.). The return on investment is calculated based on a $ valuation of each action generated through the game (e.g., 1 Google review = 1 $). If, despite following our recommendations, the subscription cost is not recovered within 3 months from the start of the game’s promotion, a full refund will be issued upon request. Please note that the game is considered launched once the communication materials are in place and a minimum of 30 unique players per week is reached.",
  public_prices_heading: "Return on investment guaranteed or your money back*",
  qrCodeScanInstruction:
    "Scan this QR code with your mobile to test your game.",
  quantity: "Quantity",
  quantity_per_week_placeholder: "Maximum quantity per week",
  redeem_4_digits_explanation:
    "A member of your staff will need to enter a 4-digit code on the winner's phone.",
  redeem_code_4_digits: "Validation code",
  redeem_code_validation_error: "Code must be exactly 4 digits",
  redeem_qr_code_explanation:
    "A member of your staff will need to use a smartphone to scan a QR code displayed on the winner’s phone, then record the gift handover by entering a 4-digit code (below).",
  redeem_soft_redeem_explanation:
    "Once the coupon is revealed, winners have a few minutes to show it to you and collect their gift, after which it will self-destruct automatically.",
  redeem_voucher: "Redeemed voucher",
  redeemed: "Redeemed",
  redemption_date: "Date redeemed",
  reference: "Reference",
  referral_plays: "Referral plays",
  refunded: "Refunded",
  reminder_12h: "12h",
  reminder_24h: "24h",
  reminder_d_plus_3: "D+3",
  reminder_disabled: "Disabled",
  reminder_m_plus_1: "M+1",
  reminder_m_plus_12: "M+12",
  reminder_m_plus_2: "M+2",
  reminder_m_plus_3: "M+3",
  reminder_m_plus_4: "M+4",
  reminder_m_plus_5: "M+5",
  reminder_m_plus_6: "M+6",
  reminder_w_plus_1: "W+1",
  reminder_w_plus_2: "W+2",
  reminder_w_plus_3: "W+3",
  renewal_date: "Renewal",
  repeat_business: "Repeat business",
  replace_logo: "Replace the logo",
  required_field: "This field is required",
  reset_account: "Reset account",
  returnToHome: "← Return to home",
  rising: "Amount",
  saas_flyers_order_delivery_action_next: "Payment",
  saas_flyers_order_delivery_action_prev: "Previous",
  saas_flyers_order_delivery_description:
    "Enter the delivery address where the promotional materials will be sent. Validate the payment for the order to be sent to our provider. You will receive the materials within 7 business days.",
  saas_flyers_order_payment_action_prev: "Previous",
  saas_flyers_order_payment_description:
    "You must enter valid payment information. Your credit card will only be used for ordering promotional materials here.",
  saas_flyers_order_payment_subheading: "Payment information",
  saas_flyers_order_quantity_action_next: "Delivery information",
  saas_flyers_order_quantity_action_prev: "Cancel",
  saas_flyers_order_quantity_description:
    "We offer many point-of-sale advertisement options. Every one is suitable for a given case (takeaway orders, table orders, etc)",
  saas_flyers_order_quantity_thead_description: "Description",
  saas_flyers_order_quantity_thead_quantity: "Quantity",
  saas_flyers_order_quantity_thead_total_price_ht: "Total excl. tax",
  saas_flyers_order_quantity_thead_type: "Type",
  saas_flyers_order_quantity_thead_unit_price_ht: "Unit price",
  saas_game_configuration_game_preview_label: "Game preview",
  saas_game_configuration_logo_and_colors_heading: "Logo and colors",
  saas_game_configuration_logo_and_colors_subheading:
    "Customize your game by adding your logo and colors.",
  saas_summary_completed_section_action_order_pdf: "Order",
  save: "Save",
  saving: "Saving...",
  search: "Search",
  searchPlaceholder: "Search 🔎",
  select: "Select",
  selectAtLeastOneOption: "Select at least one option",
  selectButton: "Select",
  select_account: "Select a venue",
  select_color: "Choose color",
  select_highlight: "Select a model",
  select_highlight_required_title: "Selection required",
  select_highlight_required_message: "Please select a game before continuing.",
  selectedText: "Selected",
  send: "Send",
  send_comment: "Send comments",
  send_email: "Do not hesitate to send an email to",
  sending: "Sending...",
  sent_sponsor_legend: "Number of share",
  settings_section_coupons: "Gift coupons",
  settings_section_dates: "Game dates",
  settings_section_display: "Display",
  shipping_address_city: "City",
  shipping_address_city_placeholder: "New York",
  shipping_address_country: "Country",
  shipping_address_country_placeholder: "Select a country",
  shipping_address_postal_code: "Postal code",
  shipping_address_postal_code_placeholder: "12345",
  shipping_address_required:
    "Please complete all required shipping address fields before proceeding.",
  shipping_address_street: "Street & number",
  shipping_address_street_placeholder: "1252 Main Street",
  shipping_name: "Shipping recipient name",
  shipping_phone_number: "Shipping recipient phone number",
  show_all_emojis: "Show all Emojis",
  showing: "Showing",
  signup_access_account: "Access your account",
  signup_already_have_account: "I already have an account",
  signup_background_image_alt: "Background image",
  signup_create_account: "Let's go",
  signup_create_account_link: "Create an account",
  signup_create_free_account: "Let's go",
  signup_email_placeholder: "Insert your email address",
  signup_email_required: "Email address is required",
  signup_generic_error:
    "An error occurred during registration. Please try again.",
  signup_heading:
    "Create your account in 2 minutes and generate hundreds of Google reviews!",
  signup_heading_email:
    "You will receive an authentication code to finalize your account creation",
  signup_heading_promocode: "Launch your game in 2 minutes tops!",
  signup_invalid_email: "Invalid email address",
  signup_login_button: "Sign in",
  signup_logo_alt: "Kadow logo",
  signup_wording_ambassador_light:
    "Create your free account and start getting more Google reviews!",
  signup_wording_ambassador_premium:
    "Create your account to launch your Ambassador program!",
  signup_wording_loyalty_light:
    "Create your free account to launch your loyalty game!",
  signup_wording_loyalty_premium:
    "Create your account to launch your loyalty game!",
  signup_wording_super_premium:
    "Create your account and launch your first game!",
  snapchatLinkPlaceholder: "Link to your Snapchat page",
  snapchatProfileStatus: "Snapchat Profile",
  soft_redeem_delay: "Self-destruction delay",
  somethingWentWrong: "Something went wrong.",
  source: "Source",
  sponsoree_authenticated_legend: "Authenticated referral",
  srdelay_10_minutes: "10 minutes",
  srdelay_1_hour: "1 hour",
  srdelay_20_minutes: "20 minutes",
  srdelay_2_hours: "2 hours",
  srdelay_30_minutes: "30 minutes",
  srdelay_45_minutes: "45 minutes",
  srdelay_5_minutes: "5 minutes",
  standard_skin: "Standard",
  start: "Start",
  start_date: "Start",
  start_immediately: "Start immediately",
  status: "Status",
  step_email_collect: "Leave your email address",
  step_facebook_like: "Like the Facebook page",
  step_google_reviews: "Leave a Google review",
  step_ig_story: "Create an Instagram story",
  step_instagram_follow: "Follow your Instagram",
  step_phone_collect: "Leave your phone number",
  step_snapchat_follow: "Follow your Snapchat",
  step_social_photo_action: "Take a nice photo",
  step_sponsorship_action: "Refer a friend",
  step_tripadvisor_review: "Leave a TripAdvisor review",
  sub_duration_monthly: "monthly",
  sub_duration_yearly: "yearly",
  subscribe_and_pay_on_date: "Get my free, no obligation trial month",
  subscribe_button: "Subscribe",
  subscription: "Subscription",
  subscription_start_date_label: "Subscription start date",
  subscription_start_label: "Subscription start",
  support_email: "clients@kadow.club",
  support_request_description:
    "Can't find a particular support? Tell us in a few words what you have in mind and we'll get back to you quickly",
  surprise_gift: "1 surprise gift",
  synthesis: "Synthesis",
  technical_error: "Technical error",
  terms_link:
    "https://s3.eu-west-3.amazonaws.com/cadeaudelamaison.com/kadow/pdf/kadow_club_terms_and_conditions_of_sale_english.pdf",
  terms_of_sale: "Terms of Sale",
  testMyGameButton: "Test my game",
  time_zone: "Timezone",
  timezone: "Timezone",
  to: "To",
  to_pay: "To pay",
  tokens: "Tokens",
  total: "Total: ",
  trigger: "Trigger",
  tripAdvisorPageStatus: "Trip Advisor rating page",
  turn_your_tablet: "Please turn your tablet.",
  type: "Type",
  typeTableHeader: "Type",
  uncategorized: "Direct access",
  unknown: "Unknown",
  unknown_game_error: "Unknown game: {{game}}",
  unsubscribe_back_home: "Back to home",
  unsubscribe_confirm_button: "Confirm unsubscription",
  unsubscribe_confirm_message: "Are you sure you want to leave us?",
  unsubscribe_confirm_title: "Confirm unsubscription",
  unsubscribe_immediately_success_message:
    "Your unsubscription is effective immediately.",
  unsubscribe_reason_avoid_renewal: "I want to avoid automatic renewal",
  unsubscribe_reason_closing_business: "I'm closing or selling the business",
  unsubscribe_reason_competitor: "I'm going to a competitor",
  unsubscribe_reason_customers_bored:
    "My customers are bored of the game/don't play anymore",
  unsubscribe_reason_error: "Please select at least one reason",
  unsubscribe_reason_no_budget: "I don't have the budget anymore",
  unsubscribe_reason_no_prizes:
    "I don't wish to make my customers win prizes anymore",
  unsubscribe_reason_no_roi: "I see no return on investment",
  unsubscribe_reason_not_adapted: "This product is not adapted to my business",
  unsubscribe_reason_objectives_reached: "I already reached my objectives",
  unsubscribe_reason_temporary: "It's temporary, I will be back soon",
  unsubscribe_reasons_message:
    "Please indicate the reason for ending your subscription:",
  unsubscribe_reasons_title: "Reason for unsubscription",
  unsubscribe_success_message: "Your subscription will end on {{endDate}}",
  unsubscribe_success_title: "Your unsubscription has been recorded",
  unsupportedPaymentError: "Unsupported payment case",
  until_tomorrow: "Until tomorrow",
  upgrade_plan: "Upgrade your plan",
  upsell_banner_free_benefit_1:
    "- Customize your game with your logo and colors",
  upsell_banner_free_benefit_2:
    "- Retain your customers with gift coupons designed to bring them back quickly",
  upsell_banner_free_benefit_3:
    "- Ask your customers to follow your social media accounts",
  upsell_banner_free_benefit_4:
    "- Access our catalog of games, calls to action, and grand prizes",
  upsell_banner_free_benefit_5: "- Get advice from our experts",
  upsell_banner_free_title: "What you get by going Premium + 🏆",
  upsell_banner_free_trial_button: "Request a free trial",
  upsell_banner_paid_tip_1: "- Set up at least 2 promotional materials",
  upsell_banner_paid_tip_2:
    "- Choose the gift card handed directly to your customers (it's the most effective channel 🥇)",
  upsell_banner_paid_tip_3:
    "- Combine high-value prizes in small quantities with low-value prizes in large quantities",
  upsell_banner_paid_tip_4:
    "- Even your low-value prizes should remain attractive if you want to bring your customers back",
  upsell_banner_paid_tip_5:
    "- Secure your revenue from redeemed prizes with consistent redemption conditions (minimum purchase etc.)",
  upsell_banner_paid_title: "💡 Our tips to maximize your results",
  upsell_ctas: "Premium + Actions",
  upsell_game_title: "Premium + Games",
  upsell_premium_button: "Go Premium +",
  utm_source_4_digit_code_email: "4-digit code email",
  utm_source_a3_poster: "A3 poster",
  utm_source_a4_poster: "A4 poster",
  utm_source_a6_flyer: "A6 flyer",
  utm_source_balloon_pop_event: "Highlight - balloon pop",
  utm_source_banner: "Banner",
  utm_source_banner_stand: "Banner stand",
  utm_source_big_prize_defeat: "Monthly lottery defeat",
  utm_source_big_prize_reminder: "Monthly lottery reminder",
  utm_source_business_card: "Business card",
  utm_source_classic_stickers: "Classic stickers",
  utm_source_coaster: "Coaster",
  utm_source_dome_stickers: "Dome stickers",
  utm_source_easel: "Table stand",
  utm_source_email: "Email",
  utm_source_expired_coupon: "Expired prize voucher",
  utm_source_facebook: "Facebook",
  utm_source_flyer: "Flyer",
  utm_source_forecast_cancellation: "Forecast cancellation",
  utm_source_forecast_confirmation: "Forecast confirmation",
  utm_source_forecast_result: "Forecast result",
  utm_source_game: "Game",
  utm_source_gift_retrieved: 'Email "prize redeemed"',
  utm_source_gift_won: 'Email "prize won"',
  utm_source_halloween_event: "Highlight - Halloween",
  utm_source_insert: "Insert",
  utm_source_instagram: "Instagram",
  utm_source_instagram_story: "Instagram story",
  utm_source_laminated_stickers: "Laminated stickers",
  utm_source_lottery_ticket_won_email: "Email 'lottery ticket won'",
  utm_source_manual_photo_validation: "Manual photo validation",
  utm_source_newsletter: "Newsletter",
  utm_source_pizza_box: "Pizza box",
  utm_source_placemat: "Placemat",
  utm_source_poster: "Poster",
  utm_source_qr_code: "QR code",
  utm_source_screen: "Screen",
  utm_source_sea: "SEA",
  utm_source_share: "Share",
  utm_source_sms: "SMS",
  utm_source_social_media: "Social media",
  utm_source_takeaway: "Takeaway",
  utm_source_terminal: "Terminal",
  utm_source_test: "Test",
  utm_source_tokens_offered_15th: "Tokens offered (15th of month)",
  utm_source_website: "Website",
  utm_source_welcome_email_day_3: "Welcome email (Day 3)",
  utm_source_whatsapp: "WhatsApp",
  utm_source_window_decal: "Window decal",
  utm_source_wom_referral_plays: "Word of mouth - referral plays",
  utm_source_wom_referral_retrieves: "Word of mouth - referral retrieves",
  utm_source_wordle_event: "Highlight - wordle",
  utm_stickers: "Stickers",
  validPhoneNumberMessage: "Please enter a valid phone number",
  validate: "Send to print",
  validate_button: "Validate",
  view: "View",
  virality_actions_label: "Actions performed",
  virality_desktop_warning: "On desktop, space too large for this graph.",
  virality_drive_to_store_label: "Drive-to-store",
  virality_sponsorees_label: "Sponsorees",
  visit: "Visit",
  vouchers: "Vouchers (classical game)",
  wellness: "Beauty & wellness",
  what_support_looking_for: "What type of support are you looking for? *",
  winners: "Winners",
  won: "Won",
  yes: "Yes",
  yourAnimationsHeading: "Dashboard",
  yourGameHeading: "Your game",
  your_animation: "Games",
  youtube_video_player: "YouTube video player"
};

export default en;
